import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { IResource } from "../../../models";
import { CreateEditAgendaItemResourceForm, ICreateEditAgendaItemResourceFormState } from ".";
import { useEditAgendaItemResource } from "../../../http";

interface IProps {
  resource: IResource;
  agendaStepGuid: string;
  visible: boolean;
  onUpdated: () => void;
  onCancelled: () => void;
}

const EditAgendaItemResourceModal = (props: IProps) => {
  const { mutate, isLoading } = useEditAgendaItemResource();
  const { formState, control, handleSubmit, reset } = useForm<ICreateEditAgendaItemResourceFormState>({
    defaultValues: {
      title: props.resource?.title ?? "",
      url: props.resource?.url ?? "",
      isEmbedded: props.resource?.isEmbedded ?? false,
      sortOrder: props.resource?.sortOrder ?? "",
    },
  });

  useEffect(() => {
    reset({
      title: props.resource?.title ?? "",
      url: props.resource?.url ?? "",
      isEmbedded: props.resource?.isEmbedded ?? false,
      sortOrder: props.resource?.sortOrder ?? "",
    });
  }, [props.resource, reset]);

  async function handleUpdateClicked() {
    if (props.resource === undefined) {
      return;
    }

    handleSubmit((data) => {
      mutate(
        {
          agendaItemGuid: props.agendaStepGuid,
          resourceGuid: props.resource.guid,
          title: data.title,
          url: data.url,
          isEmbedded: data.isEmbedded,
          sortOrder: data.sortOrder,
        },
        {
          onSuccess: () => {
            props.onUpdated();
          },
        }
      );
    })();
  }

  function handleClose(_: object, reason: string) {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    handleCancelClicked();
  }

  function handleCancelClicked() {
    reset(undefined, { keepDefaultValues: true });
    props.onCancelled();
  }

  return (
    <Dialog open={props.visible} onClose={handleClose}>
      <DialogTitle>Edit Resource</DialogTitle>
      <DialogContent>
        <CreateEditAgendaItemResourceForm formState={formState} control={control} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={isLoading} onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isLoading}
          endIcon={isLoading ? <CircularProgress size={20} sx={{ color: "grey.400" }} /> : null}
          onClick={handleUpdateClicked}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { EditAgendaItemResourceModal };
